import { render } from "./ExamPatientAddOffcanvas.vue?vue&type=template&id=5f2fba3b&scoped=true"
import script from "./ExamPatientAddOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamPatientAddOffcanvas.vue?vue&type=script&lang=js"

import "./ExamPatientAddOffcanvas.vue?vue&type=style&index=0&id=5f2fba3b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2fba3b"]])

export default __exports__